export enum IncomeConceptEnum {
  pagoFacturas = 1,
  anticipos = 2
}